export default __webpack_public_path__ + "static/homepagePartners-NL-c84da11600fe1600a22ad6118d8d6a65.png";